import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '../hooks/useScrollAnimation';
import SectionHeading from './common/SectionHeading';

const steps = [
  {
    number: '01',
    title: 'We Analyze',
    description: 'We model your fan base and project revenue. You see the numbers before committing to anything.',
  },
  {
    number: '02',
    title: 'We Build & Launch',
    description: 'ESF funds and delivers your white-label platform. Cards, app, merchant network — all live in weeks.',
  },
  {
    number: '03',
    title: 'You Earn',
    description: 'Revenue flows from day one. Real-time dashboard tracks every transaction across your fan base.',
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="relative py-24 md:py-32 bg-esf-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="How It Works"
          headline="Live in weeks, not months"
        />

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
          className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 relative"
        >
          <div className="hidden md:block absolute top-12 left-[16.67%] right-[16.67%] h-px bg-gradient-to-r from-esf-blue/50 via-esf-cyan/50 to-esf-blue/50" />

          {steps.map((step) => (
            <motion.div key={step.number} variants={fadeInUp} className="relative text-center">
              <div className="relative z-10 w-12 h-12 mx-auto mb-6 rounded-full border-2 border-esf-blue bg-esf-dark flex items-center justify-center">
                <span className="text-sm font-bold text-esf-blue">{step.number}</span>
              </div>
              <h3 className="text-body-lg font-semibold text-esf-white mb-3">{step.title}</h3>
              <p className="text-body-sm text-esf-gray-300 max-w-xs mx-auto text-pretty">{step.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;
